import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    resetPadding: {
      padding: 0,
    },
    cardContainer: {
      borderBottom: '1px solid #F5F8FA',
    },
    card: {
      minWidth: 200,
      '&:not(:last-child)': {
        borderRight: '1px solid #F5F8FA',
      },
    },
    mt: {
      marginTop: theme.spacing(6),
    },
    list: {
      width: '100%',
      height: '100%',
      maxHeight: 312,

      overflow: 'auto !important',
      '&::-webkit-scrollbar': {
        height: 5,
        width: 5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.colors.gray4,
        borderRadius: 15,
      },
      scrollbarWidth: 'thin', // Firefox suport
      msOverflowStyle: 'auto', // IE10+ Support
    },
    iconButton: {
      padding: 2,
      marginRight: 0,
      background: '#F5F8FA',
      color: '#14171A',
      '&:hover': {
        background: 'inherit',
      },
    },
    closeIcon: {
      width: 10,
      height: 10,
    },
    active: {
      background: '#F5F8FA',
    },
    addMargin: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(2),
    },
    inputSearch: {
      background: '#F5F8FA',
      borderRadius: 20,
      maxHeight: 35,
      height: '100%',
      '& div': {
        maxHeight: 35,
        '& fieldset': {
          border: 'none',
        },
      },
    },
    selectedCount: {
      marginTop: theme.spacing(1),
    },
    button: {
      textTransform: 'none',
      color: '#0094FF',
      '&:hover': {
        background: 'none',
      },
    },
    cancelButton: {
      marginRight: theme.spacing(2),
      color: theme.palette.colors.gray4,
    },
    overflow: {
      '& ul': {
        maxHeight: '312px',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
          height: 5,
          width: 5,
        },
        '&::-webkit-scrollbar-thumb': {
          background: theme.palette.colors.gray4,
          borderRadius: 15,
        },
        scrollbarWidth: 'thin', // Firefox suport
        msOverflowStyle: 'auto', // IE10+ Support
      },
    },
  }),
);

export default useStyles;
